<template>
	<div>
		<SendMsg style="height: 400px" @onSave="onSave" sourceType="tel"></SendMsg>
	</div>
</template>

<script>
import SendMsg from '@/views/im-channel/message/details/editor';
export default {
	components: {
		SendMsg
	},
	data() {
		return {
			queryObj: {
				customerId: '',
				tuId: '',
				sourceType: '',
				subBrand: '',
				channel: '',
				appId: '',
				openId: ''
			},
			loading: false
		}
	},
	// watch: {
	// 	$route: {
	// 		hander(data) {
	// 			console.log('=====111====')
	// 			console.log(this.$route.query)
	// 			console.log(data)
	// 			this.queryObj = Object.assign(this.queryObj, data);
	// 			console.log(this.queryObj)
	// 			console.log('=====111====')
	// 		},
	// 		deep: true,
	// 		immediate:true
	// 	}
	// },
	mounted() {
		console.log('=====222====')
		console.log(this.$route.query)
		this.queryObj = Object.assign(this.queryObj, this.$route.query);
		console.log(this.queryObj)
		console.log('=====222====')
	},
	methods: {
		onSave(data) {
			if(this.loading) return;
			this.loading = true;
			data['brand'] = this.queryObj.subBrand;
			data['channel'] = this.queryObj.channel;
			data['customerId'] = this.queryObj.customerId;
			this.$api.apiPostSendWeiXinLy(this.queryObj.appId, this.queryObj.openId, data).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				}
				this.$message.success( '留言成功！');
				localStorage.setItem('socketSendMsg', Math.random());
				this.loading = false;
			});
		},
	}
}
</script>